// extracted by mini-css-extract-plugin
export default {"opensource_section":"OpenSource_opensource_section__CiuWP","heading":"OpenSource_heading__5voBp","blink":"OpenSource_blink__flYe7","contribution":"OpenSource_contribution__YmmA6"};